export default __webpack_public_path__ + "static/media/03.72251686.png";